<div *ngIf="sectionVisible" class="sales-messages-section">
  <h2 class="sales-messages-section__title" [innerHTML]="'SALES_MESSAGES_SECTION.title' | translate | safeHtml"></h2>
  <div class="sales-messages-section__messages">
    <app-sales-message *ngFor="let config of messagesConfig"
                       class="sales-messages-section__message"
                       [config]="config"
    ></app-sales-message>
  </div>
</div>
